import React from 'react'
import { connect } from 'react-redux';


function mapStateToProps(state, ownProps) {
    return {
        permissions: state.user.permissions
    };
}



export function permissioned(WrappedComponent) {

    var PermissionedComponent = class extends React.Component {
        constructor(props, context) {
            super(props, context);
            this.state = {
                permissions: props.permissions ? props.permissions : {}
            };

        }

        componentWillReceiveProps(nextProps) {
            this.setState({ permissions: nextProps.permissions });
        }
        render() {
            let permission = this.props.permission;
            if (!this.state.permissions[permission])
                return (<WrappedComponent {...this.props} />);
            return null;
        }
    }
    return connect(mapStateToProps)(PermissionedComponent);
}




// WEBPACK FOOTER //
// ./src/components/common/permissionedHoc.js